<div class="filters">
  @for (filter of appliedFilters; track filter; let i = $index) {
    <div class="filter-container">
      <span class="filter" [id]="'applied-filter-'+i" [ngStyle]="{'background-color': getFilterColor(filter)}">
        {{filter.replace('journey', 'experience') | titleText}}<i class="fa fa-close" (click)="removeFilter(filter)"></i>
      </span>
    </div>
  }
  @if (showClearBtn) {
    <div class="filter-container">
      @if (appliedFilters.length > 1) {
        <button class="filter filter--clear" (click)="clearFilters()" id='clear-all'>Clear All</button>
      }
    </div>
  }
</div>
